export * as textStyles from './Text.module.css';
export * from './Text';
